import { ensure, numberType, stringType, TType } from "types";

export type TCustomFieldType = "TEXT" | "BOOLEAN" | "DATE" | "NUMBER";

export interface ICustomField {
  name: string;
  order: number;
  value: string;
  type: TCustomFieldType;
}

const configCustomFieldType: TType<ICustomField> = {
  name: stringType(""),
  order: numberType(0),
  value: stringType(""),
  type: stringType(""),
};

export const customFieldType = ensure(configCustomFieldType);
